import { createSlice } from '@reduxjs/toolkit';
import { getAllBuySellVehicleApi, getAllVehicleApi, getBuySellVehicleByvehilceIdApi } from './vehicleApi';

// ----------------------------------------------------------------------

const initialState = {
  isVehicleLoading: false,
  vehicleList: [],
  isBuySellVehicleLoading: false,
  buySellVehicleList: [],
  vehicleDetail: {}
};

const slice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllVehicleApi.pending]: (state) => {
      state.isVehicleLoading = true;
    },
    [getAllVehicleApi.fulfilled]: (state, action) => {
      state.vehicleList = action.payload;
      state.isVehicleLoading = false;
    },
    [getAllVehicleApi.rejected]: (state) => {
      state.isVehicleLoading = false;
    },
    [getAllBuySellVehicleApi.pending]: (state) => {
      state.isBuySellVehicleLoading = true;
    },
    [getAllBuySellVehicleApi.fulfilled]: (state, action) => {
      state.buySellVehicleList = action.payload;
      state.isBuySellVehicleLoading = false;
    },
    [getAllBuySellVehicleApi.rejected]: (state) => {
      state.isBuySellVehicleLoading = false;
    },
    [getBuySellVehicleByvehilceIdApi.fulfilled]: (state, action) => {
      state.vehicleDetail = action.payload;
    }
  }
});
export const vehicleAction = slice.actions;

export default slice.reducer;
